import '.d{display:flex;}.ssr-plugin'
import '.s{flex-direction:row;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.c0{height:100vh;}.ssr-plugin'
import '.ap{flex-grow:1;}.ssr-plugin'
import '.aa{min-width:0px;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.c5{overflow-y:auto;}.ssr-plugin'
import '.fd{margin-top:2rem;}.ssr-plugin'
import '.cy{min-height:0px;}.ssr-plugin'
import '.fr{max-width:60rem;}.ssr-plugin'
import '.fs{margin-left:auto;}.ssr-plugin'
import '.ft{margin-right:auto;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'
import Column from '@app/components/layout/Column'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Column alignItems="stretch">
        <div className="d s v c0"
          style={{
            padding: isMobile ? '0rem' : '1.5rem',
            gap: isMobile ? 0 : '5rem',}}
        >
          <InitiativeSideBar />

          <div className="ap aa d e"
          >
            <DashboardNavBar
              initiativeDashboard={true}
              style={{ backgroundColor: 'var(--palette-white)' }}
            />
            <div className="n ap c5"
            >
              <div className="n d e fd cy fr fs ft"
                style={{
                  gap: gap,
                  paddingInline: isMobile ? '1rem' : 0,}}
              >
                {children}
              </div>
            </div>
          </div>
        </div>
      </Column>
    </ClientOnly>
  )
}
